<template>
  <el-dialog
    :title="'头像拍照'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="60%"
  >
    <el-form
      ref="faceBean"
      :model="faceBean"
      label-width="100px"
      style="width:95%;"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="考生照片" style="margin: 0;">
            <video
              v-if="openSuccess"
              id="videoCamera"
              autoplay
              width="240"
              height="240"
              style="border: solid 1px black;"
            />
          </el-form-item>
        </el-col>
        <el-col
          :span="3"
          style="height: 200px;display: flex; justify-content: center;align-items: center;flex-wrap: wrap;"
        >
          <el-button
            v-if="openSuccess"
            size="small"
            type="primary"
            style="width: 80px; text-align: center;"
            @click="setImage()"
            >拍照</el-button
          >
        </el-col>
        <el-col
          :span="9"
          style="display: flex; justify-content: center; align-items: center;"
        >
          <canvas
            id="canvasCamera"
            style="display:none;"
            width="640"
            height="480"
          />
          <img :src="imgSrc1" alt width="320" height="240" />
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="danger" @click="closeDialog">关 闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { addPerson } from "@/api/login";
export default {
  props: ["imgSrc1"],
  data() {
    return {
      visible: false,
      faceBean: {
        fileBase64: "",
        extName: "",
        token: ""
      },
      imgSrc: "",
      video: null,
      context: null,
      canvas: null,
      openSuccess: true
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.imgSrc = "";
        setTimeout(() => {
          this.getCamera();
        }, 1000);
      } else {
        this.closeCamera();
      }
    }
  },
  created() {
    // setTimeout(() => {
    //   this.getCamera();
    // }, 1000);
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    init() {
      this.visible = true;
      this.faceBean.token = this.token;
    },
    // 打开摄像头
    getCamera() {
      this.openSuccess = true;
      this.video = document.getElementById("videoCamera");
      this.canvas = document.getElementById("canvasCamera");
      this.context = this.canvas.getContext("2d");
      const errocb = () => {
        this.$message.error("摄像头打开失败！");
        this.openSuccess = false;
      };
      if (navigator.webkitGetUserMedia) {
        navigator.webkitGetUserMedia(
          { audio: false, video: true },
          stream => {
            // video.src=window.URL.createObjectURL(stream);
            this.video.srcObject = stream;
            this.video.play();
          },
          errocb
        );
      } else if (navigator.mediaDevices.getUserMedia) {
        // var constraints = { audio: true, video: { width: 1280, height: 720 } };
        const constraints = { audio: false, video: true };
        navigator.mediaDevices.getUserMedia(constraints).then(stream => {
          // var video = document.querySelector('video');
          this.video.srcObject = stream;
          this.video.onloadedmetadata = () => {
            this.video.play();
          };
        },errocb);
      } else if (navigator.getUserMedia) {
        navigator.getUserMedia(
          { audio: false, video: true },
          stream => {
            this.video.src = window.webkitURL.createObjectURL(stream);
            this.video.srcObject = stream;
            this.video.play();
          },
          errocb
        );
      } else {
        alert("你的浏览器不支持打开摄像头");
      }
    },
    //  绘制图片（拍照功能）
    setImage() {
      // if (this.video) {
      //   alert(this.video.videoWidth + "," + this.video.videoHeight);
      //   return;
      // }
      this.context.drawImage(
        this.video,
        0,
        0,
        this.video.videoWidth,
        this.video.videoHeight
      );
      this.imgSrc = this.canvas.toDataURL("image/png");
      this.faceBean.extName = this.imgSrc.substring(
        this.imgSrc.indexOf("/") + 1,
        this.imgSrc.indexOf(";")
      );
      this.faceBean.fileBase64 = this.imgSrc.substring(22);
      addPerson(this.faceBean).then(res => {
        if (res.code === 200) {
          this.$message.success("上传照片成功");
          this.visible = false;
          this.$emit("refreshData");
        } else {
          //this.$message.error(res.msg);
        }
      });
    },
    // 关闭摄像头
    closeCamera() {
      if (this.openSuccess) {
        this.video.srcObject.getTracks()[0].stop();
      }
    },
    // 关闭弹出层
    closeDialog() {
      // this.closeCamera();
      this.visible = false;
    },
    // 重写文件上传方法
    fileUpload(file) {
      this.fileToBase64(file.file)
        .then(res => {
          // console.log(res)
          this.imgSrc = res;
          this.dataForm.extName = res.substring(
            res.indexOf("/") + 1,
            res.indexOf(";")
          );
          const len = 19 + this.dataForm.extName.length;
          this.dataForm.fileBase64 = res.substring(len);
          // console.log(this.dataForm.fileBase64)
        })
        .catch(err => {
          console.log(err);
          this.$message.error(err);
        });
    },
    // 转base64
    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        let fileResult = "";
        if (file.size > 1024 * 1024 * 4) {
          reject("文件大小不能超过4M");
        }
        reader.readAsDataURL(file);
        // 开始转
        reader.onload = () => {
          fileResult = reader.result;
          // data:image/jpeg;base64,
        };
        // 转 失败
        reader.onerror = function(error) {
          reject(error);
        };
        // 转 结束  咱就 resolve 出去
        reader.onloadend = function() {
          resolve(fileResult);
        };
      });
    }
  }
}
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
